// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import ServerError from '../../components/ServerError/ServerError';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import AdminList from '../../components/AdminList/AdminList';
import SelectFormInput from '../../components/SelectFormInput/SelectFormInput';
import SearchField from '../../components/SearchField/SearchField';
import _ from 'lodash/fp';
import {formatOrderState} from '../../helpers/tableHelpers';
import {
  fetchOrders,
  filterByQuery,
  filterByProjectId,
  filterByPurchased,
  sortItems,
} from '../../actions/purchaseOrderList';

const purchasedFilter = [{
  label: 'Väntar på inköp',
  value: false,
}, {
  label: 'Inköp klart',
  value: true,
}];

const columns = [{
  property: 'apartment.project.name',
  header: {
    label: 'Projekt',
  },
}, {
  property: 'apartment.objectId',
  header: {
    label: 'Lägenhet',
  },
}, {
  property: 'user.person.name',
  header: {
    label: 'Kund',
  },
}, {
  property: 'totalPrice',
  header: {
    label: 'Värde',
  },
}, {
  property: 'state',
  header: {
    label: 'Status',
  },
  cell: {
    formatters: [
      formatOrderState,
    ],
  },
}];

export type Props = {
  history: Object,
  error?: any,
  fetchOrders: Function,
  filters: Object,
  filterByProjectId: Function,
  filterByQuery: Function,
  filterByPurchased: Function,
  isFetching: boolean,
  orders: any[],
  location: { pathname: string },
  projects: any[],
  sortItems: typeof sortItems,
};

class PurchaseOrdersContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.fetchOrders();
  }

  render() {
    const {
      history,
      error,
      filters,
      isFetching,
      orders,
      location: {pathname},
      projects,
      filterByProjectId,
      filterByQuery,
      filterByPurchased,
      sortItems,
    } = this.props;
    return (
      <div className="OrdersContainer relative">
        <ServerError error={error} />
        <LoadingIndicator isLoading={isFetching} />
        <div className="row align-middle">
          <div className="column">
            <SearchField
              value={filters.query || ''}
              onClear={e => filterByQuery('')}
              onChange={e => filterByQuery(e.target.value)} />
          </div>
        </div>
        <div className="box">
          <div className="row align-middle">
            {projects &&
              <div className="column">
                <SelectFormInput
                  input={{
                    value: filters.projectId || null,
                    onBlur: _.noop,
                    onChange: project => filterByProjectId(project ? project.id : null),
                  }}
                  label="Projekt"
                  meta={{}}
                  valueKey="id"
                  labelKey="name"
                  clearable={true}
                  options={projects}
                  placeholder="Alla" />
              </div>
            }
            <div className="column">
              <SelectFormInput
                input={{
                  value: filters.isPurchased,
                  onBlur: _.noop,
                  onChange: purchased => filterByPurchased(purchased ? purchased.value : false),
                }}
                label="Status"
                meta={{}}
                valueKey="value"
                labelKey="label"
                clearable={false}
                options={purchasedFilter} />
            </div>
          </div>
          {orders &&
            <AdminList
              query={filters.query}
              columns={columns}
              rows={orders}
              onSort={sortItems}
              onRowSelected={row => history.push(`${pathname}/${row.id}`)} />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  purchaseOrderList: {
    error,
    isFetching,
    orders: {
      filteredList: orders,
      filters,
    },
    projects,
  },
}) => ({
  error,
  isFetching,
  orders,
  projects,
  filters,
});

const mapDispatchToProps = dispatch => ({
  fetchOrders: () =>
    dispatch(fetchOrders()),
  filterByQuery: query =>
    dispatch(filterByQuery(query)),
  filterByProjectId: projectId =>
    dispatch(filterByProjectId(projectId)),
  filterByPurchased: purchased =>
    dispatch(filterByPurchased(purchased)),
  sortItems: sorter =>
    dispatch(sortItems(sorter)),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseOrdersContainer));



// WEBPACK FOOTER //
// ./src/containers/PurchaseOrdersContainer/PurchaseOrdersContainer.js